// import React from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import Form from "react-bootstrap/Form";
// import Button from "react-bootstrap/Button";
// import Container from "react-bootstrap/Container";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import Modal from "react-bootstrap/Modal";
// import { setCustomerData } from "../../../src/app/features/counter/counterSlice";
// import { useDispatch } from "react-redux";

// const Registration = ({ setShowCustomerInfoForm, showCustomerInfoForm }) => {
//   const dispatch = useDispatch();
//   const [show, setShow] = React.useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const validationSchema = Yup.object().shape({
//     customerName: Yup.string().required("Customer Name is required"),
//     businessName: Yup.string().required("Business Name is required"),
//     email: Yup.string().email("Invalid email").required("Email is required"),
//     phoneNumber: Yup.number().required("Phone Number is required"),
//     address: Yup.string().required("Address is required"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       customerName: "",
//       businessName: "",
//       email: "",
//       phoneNumber: "",
//       address: "",
//     },
//     validationSchema,
//     onSubmit: (values) => {

//       dispatch(setCustomerData(values));
//       handleClose();
//     },
//   });

//   React.useEffect(() => {
//     handleShow();
//   }, []);

//   return (
//     <>
//       <Modal show={show}>
//         <Modal.Header>
//           <Modal.Title>Enter Customer Details :</Modal.Title>
//           <div
//             onClick={() => setShowCustomerInfoForm(!showCustomerInfoForm)}
//             style={{ cursor: 'pointer' }} // Add some styling for better UX
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <line x1="18" y1="6" x2="6" y2="18" />
//               <line x1="6" y1="6" x2="18" y2="18" />
//             </svg>

//           </div>
//         </Modal.Header>
//         <Modal.Body>
//           <Container>
//             <Row>
//               <Col>
//                 <Form onSubmit={formik.handleSubmit}>
//                   <Form.Group className="mb-3" controlId="formBasicEmail">
//                     <Form.Label>Customer Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="customerName"
//                       placeholder="Enter Customer Name"
//                       value={formik.values.customerName}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.customerName &&
//                       formik.errors.customerName && (
//                         <div className="text-danger">
//                           {formik.errors.customerName}
//                         </div>
//                       )}
//                   </Form.Group>

//                   <Form.Group className="mb-3" controlId="formBasicEmail">
//                     <Form.Label>Business Name</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="businessName"
//                       placeholder="Enter Business Name"
//                       value={formik.values.businessName}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.businessName &&
//                       formik.errors.businessName && (
//                         <div className="text-danger">
//                           {formik.errors.businessName}
//                         </div>
//                       )}
//                   </Form.Group>

//                   <Form.Group className="mb-3" controlId="formBasicEmail">
//                     <Form.Label>Email</Form.Label>
//                     <Form.Control
//                       type="email"
//                       name="email"
//                       placeholder="Enter Email"
//                       value={formik.values.email}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.email && formik.errors.email && (
//                       <div className="text-danger">{formik.errors.email}</div>
//                     )}
//                   </Form.Group>

//                   <Form.Group className="mb-3" controlId="formBasicEmail">
//                     <Form.Label>Phone Number</Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="phoneNumber"
//                       placeholder="Enter Phone Number"
//                       value={formik.values.phoneNumber}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.phoneNumber &&
//                       formik.errors.phoneNumber && (
//                         <div className="text-danger">
//                           {formik.errors.phoneNumber}
//                         </div>
//                       )}
//                   </Form.Group>

//                   <Form.Group className="mb-3" controlId="formBasicEmail">
//                     <Form.Label>Address</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="address"
//                       placeholder="Enter Address"
//                       value={formik.values.address}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                     />
//                     {formik.touched.address && formik.errors.address && (
//                       <div className="text-danger">{formik.errors.address}</div>
//                     )}
//                     <Form.Text className="text-muted text-center fst-italic">
//                       We'll never share your info with anyone else.
//                     </Form.Text>
//                   </Form.Group>
//                   <Col className="d-flex justify-content-between">
//                     <Button variant="dark" onClick={() => setShowCustomerInfoForm(!showCustomerInfoForm)}>
//                       Skip
//                     </Button>
//                     <Button variant="dark" type="submit">
//                       Submit
//                     </Button>
//                   </Col>
//                 </Form>
//               </Col>
//             </Row>
//           </Container>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Registration;


import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import { setCustomerData } from "../../../src/app/features/counter/counterSlice";
import { useDispatch, useSelector } from "react-redux";

const Registration = ({ setShowCustomerInfoForm, showCustomerInfoForm }) => {
  const dispatch = useDispatch();
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const customerUserData = useSelector((state) => state.counter1.customerData);

  const validationSchema = Yup.object().shape({
    customerFirstName: Yup.string().required("First Name is required"),
    customerLastName: Yup.string().required("Last Name is required"),
    businessName: Yup.string(),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phoneNumber: Yup.string().required("Phone Number is required"),
    billAddress1: Yup.string().required("Billing Address is required"),
    billAddress2: Yup.string(),
    billCity: Yup.string().required("Billing City is required"),
    billState: Yup.string().required("Billing State is required"),
    billZip: Yup.string().required("Billing Zip is required"),
    shipAddress1: Yup.string(),
    shipAddress2: Yup.string(),
    shipCity: Yup.string(),
    shipState: Yup.string(),
    shipZip: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      customerFirstName: customerUserData?.customerFirstName || "",
      customerLastName: customerUserData?.customerLastName || "",
      businessName: customerUserData?.businessName || "",
      email: customerUserData?.email || "",
      phoneNumber: customerUserData?.phoneNumber || "",
      billAddress1: customerUserData?.billAddress1 || "",
      billAddress2: customerUserData?.billAddress2 || "",
      billCity: customerUserData?.billCity || "",
      billState: customerUserData?.billState || "",
      billZip: customerUserData?.billZip || "",
      shipAddress1: customerUserData?.shipAddress1 || "",
      shipAddress2: customerUserData?.shipAddress2 || "",
      shipCity: customerUserData?.shipCity || "",
      shipState: customerUserData?.shipState || "",
      shipZip: customerUserData?.shipZip || "",
    },
    validationSchema,
    onSubmit: (values) => {
      dispatch(setCustomerData(values));
      handleClose();
    },
  });


  const copyBillingToShipping = () => {
    formik.setValues((prevValues) => ({
      ...prevValues,
      shipAddress1: prevValues.billAddress1,
      shipAddress2: prevValues.billAddress2,
      shipCity: prevValues.billCity,
      shipState: prevValues.billState,
      shipZip: prevValues.billZip,
    }));
  };

  React.useEffect(() => {
    handleShow();
  }, []);

  return (
    <>
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>Enter Customer Details:</Modal.Title>
          <div
            onClick={() => setShowCustomerInfoForm(!showCustomerInfoForm)}
            style={{ cursor: 'pointer' }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <Form onSubmit={formik.handleSubmit}>
                  {/* Customer Name */}
                  <Form.Group className="mb-3">
                    <Form.Label>First Name*</Form.Label>
                    <Form.Control
                      type="text"
                      name="customerFirstName"
                      placeholder="Enter First Name"
                      value={formik.values.customerFirstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.customerFirstName && formik.errors.customerFirstName && (
                      <div className="text-danger">{formik.errors.customerFirstName}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Last Name*</Form.Label>
                    <Form.Control
                      type="text"
                      name="customerLastName"
                      placeholder="Enter Last Name"
                      value={formik.values.customerLastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.customerLastName && formik.errors.customerLastName && (
                      <div className="text-danger">{formik.errors.customerLastName}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Business Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="businessName"
                      placeholder="Enter Business Name"
                      value={formik.values.businessName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Email*</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter Email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-danger">{formik.errors.email}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number*</Form.Label>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      placeholder="Enter Phone Number"
                      value={formik.values.phoneNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                      <div className="text-danger">{formik.errors.phoneNumber}</div>
                    )}
                  </Form.Group>

                  {/* Billing Address */}
                  <Form.Group className="mb-3">
                    <Form.Label>Billing Address*</Form.Label>
                    <Form.Control
                      type="text"
                      name="billAddress1"
                      placeholder="Enter Billing Address"
                      value={formik.values.billAddress1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.billAddress1 && formik.errors.billAddress1 && (
                      <div className="text-danger">{formik.errors.billAddress1}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Billing Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="billAddress2"
                      placeholder="Enter Billing Address 2"
                      value={formik.values.billAddress2}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Billing City*</Form.Label>
                    <Form.Control
                      type="text"
                      name="billCity"
                      placeholder="Enter Billing City"
                      value={formik.values.billCity}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.billCity && formik.errors.billCity && (
                      <div className="text-danger">{formik.errors.billCity}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Billing State*</Form.Label>
                    <Form.Control
                      type="text"
                      name="billState"
                      placeholder="Enter Billing State"
                      value={formik.values.billState}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.billState && formik.errors.billState && (
                      <div className="text-danger">{formik.errors.billState}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Billing Zip*</Form.Label>
                    <Form.Control
                      type="text"
                      name="billZip"
                      placeholder="Enter Billing Zip"
                      value={formik.values.billZip}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.billZip && formik.errors.billZip && (
                      <div className="text-danger">{formik.errors.billZip}</div>
                    )}
                  </Form.Group>

                  <Button
                    variant="secondary"
                    onClick={copyBillingToShipping}
                    className="mb-3"
                  >
                    Copy from Billing
                  </Button>

                  {/* Shipping Address */}
                  <Form.Group className="mb-3">
                    <Form.Label>Shipping Address</Form.Label>
                    <Form.Control
                      type="text"
                      name="shipAddress1"
                      placeholder="Enter Shipping Address"
                      value={formik.values.shipAddress1}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Shipping Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="shipAddress2"
                      placeholder="Enter Shipping Address 2"
                      value={formik.values.shipAddress2}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Shipping City</Form.Label>
                    <Form.Control
                      type="text"
                      name="shipCity"
                      placeholder="Enter Shipping City"
                      value={formik.values.shipCity}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Shipping State</Form.Label>
                    <Form.Control
                      type="text"
                      name="shipState"
                      placeholder="Enter Shipping State"
                      value={formik.values.shipState}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Shipping Zip</Form.Label>
                    <Form.Control
                      type="text"
                      name="shipZip"
                      placeholder="Enter Shipping Zip"
                      value={formik.values.shipZip}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Form.Group>

                  

                  <Col className="d-flex justify-content-between">
                    <Button variant="dark" onClick={() => setShowCustomerInfoForm(!showCustomerInfoForm)}>
                      Skip
                    </Button>
                    <Button variant="dark" type="submit">
                      Submit
                    </Button>
                  </Col>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal >
    </>
  );
};

export default Registration;

